var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "booking-calendar-header", class: [_vm.theme] },
    [
      _c("div", { staticClass: "is-flex is-align-items-center" }, [
        _c("div", { staticClass: "is-flex is-align-items-center" }, [
          _c(
            "div",
            {
              staticClass: "toggle-buttons ml-2 is-flex is-flex-direction-row",
            },
            [
              _c(
                "span",
                {
                  staticClass: "button m-0",
                  class: {
                    "is-primary is-selected": _vm.selectedDueInOut === 0,
                  },
                  staticStyle: { "border-radius": "5px 0px 0px 5px" },
                  on: {
                    click: function ($event) {
                      return _vm.changeActive(0)
                    },
                  },
                },
                [_c("span", [_vm._v("Due In")])]
              ),
              _c(
                "span",
                {
                  staticClass: "button m-0",
                  class: {
                    "is-primary is-selected": _vm.selectedDueInOut === 1,
                  },
                  staticStyle: { "border-radius": "0px 5px 5px 0px" },
                  on: {
                    click: function ($event) {
                      return _vm.changeActive(1)
                    },
                  },
                },
                [_c("span", [_vm._v("Due Out")])]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "ml-6 mr-4 is-flex is-flex-direction-row is-align-items-center is-justify-content-space-between",
              staticStyle: { "min-width": "240px" },
            },
            [
              _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleArrowClick("left")
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass: "arrow-buttons mdi mdi-chevron-left mdi-30px",
                  }),
                ]
              ),
              _c("div", { staticClass: "is-flex" }, [
                _c("span", { staticClass: "mdi mdi-calendar-blank-outline" }),
                _c("span", { staticClass: "ml-2 mr-2" }, [
                  _vm._v(_vm._s(_vm.dateString)),
                ]),
              ]),
              _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleArrowClick("right")
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass: "arrow-buttons mdi mdi-chevron-right mdi-30px",
                  }),
                ]
              ),
            ]
          ),
          _c("div", { staticClass: "is-flex is-flex-direction-row" }, [
            _c(
              "div",
              { staticClass: "control", staticStyle: { width: "5em" } },
              [
                _c("div", { staticClass: "pretty p-switch p-fill" }, [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: { checked: _vm.showWeekend },
                    on: {
                      change: function ($event) {
                        return _vm.handleChangeShowWeekend(!_vm.showWeekend)
                      },
                    },
                  }),
                  _vm._m(0),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", [_vm._v("Show Weekends")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }